import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { MapPin, Phone, Mail, MessageCircle } from 'lucide-react';

const Footer = () => {
  const { language, t } = useLanguage();

  const legalLinks = [
    { name: t.nav.legal, path: language === 'es' ? '/aviso-legal' : '/en/legal' },
    { name: t.nav.privacy, path: language === 'es' ? '/privacidad' : '/en/privacy' },
    { name: t.nav.cookies, path: language === 'es' ? '/cookies' : '/en/cookies' }
  ];

  return (
    <footer className="bg-[#356C8A] text-white mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div data-testid="footer-company-info">
            <img 
              src="/logo_white_bg.png" 
              alt="PASTORIA SERRALTA" 
              className="h-24 w-auto mb-4"
            />
            <p className="text-sm text-white/90">
              {t.footer.company}
            </p>
          </div>

          {/* Contact Info */}
          <div data-testid="footer-contact-info">
            <h3 className="font-semibold mb-4 text-lg">{t.contact.title}</h3>
            <div className="space-y-3 text-sm">
              <div className="flex items-start space-x-2">
                <MapPin className="h-5 w-5 text-white flex-shrink-0 mt-0.5" />
                <span className="text-white/90">{t.contact.addressValue}</span>
              </div>
              <div className="flex items-center space-x-2">
                <Phone className="h-5 w-5 text-white flex-shrink-0" />
                <a href="tel:+34638281201" className="text-white/90 hover:text-white transition-colors">
                  {t.contact.phoneValue}
                </a>
                <a 
                  href="https://wa.me/34638281201" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="ml-2 text-[#25D366] hover:text-[#1DA851] transition-colors"
                  title="WhatsApp"
                >
                  <MessageCircle className="h-5 w-5" />
                </a>
              </div>
              <div className="flex items-center space-x-2">
                <Mail className="h-5 w-5 text-white flex-shrink-0" />
                <a href="mailto:info@pastoria-serralta.com" className="text-white/90 hover:text-white transition-colors">
                  {t.contact.emailValue}
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div data-testid="footer-quick-links">
            <h3 className="font-semibold mb-4 text-lg">{t.footer.quickLinks}</h3>
            <ul className="space-y-2 text-sm">
              {legalLinks.map((link) => (
                <li key={link.path}>
                  <Link 
                    to={link.path} 
                    className="text-white/90 hover:text-white transition-colors"
                    data-testid={`footer-link-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 mt-8 pt-8 text-center text-sm text-white/80">
          <p>{t.footer.rights}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;